/**
 * Default metrics configuration values.
 */
export const defaultMetricsConfig = {
    revenue: {
        defaultRevenueRatePercent: 0,
        clientRebateSharePercent: 0,
        effectiveRebatePercent: 0,
        interchangeCreatedPercent: 0,
    },
    supplier: {
        optimizedSupplierRatePercent: 0,
    },
    paymentMethods: {
        digitalPaymentMethods: ['VIRTUAL_CARD', 'ACH', 'ACH_PLUS', 'SECURE_CARD'],
    },
};
/**
 * Loads metrics configuration from environment variables with defaults.
 */
export function loadMetricsConfig() {
    let config = {
        revenue: {
            defaultRevenueRatePercent: defaultMetricsConfig.revenue.defaultRevenueRatePercent,
            clientRebateSharePercent: defaultMetricsConfig.revenue.clientRebateSharePercent,
            effectiveRebatePercent: defaultMetricsConfig.revenue.effectiveRebatePercent,
            interchangeCreatedPercent: defaultMetricsConfig.revenue.interchangeCreatedPercent,
        },
        supplier: {
            optimizedSupplierRatePercent: defaultMetricsConfig.supplier.optimizedSupplierRatePercent,
        },
        paymentMethods: {
            digitalPaymentMethods: defaultMetricsConfig.paymentMethods.digitalPaymentMethods,
        },
    };
    if (typeof process !== 'undefined' && typeof process.env !== 'undefined') {
        config = {
            revenue: {
                defaultRevenueRatePercent: Number(process.env.METRICS_REVENUE_RATE_PERCENT) ||
                    defaultMetricsConfig.revenue.defaultRevenueRatePercent,
                clientRebateSharePercent: Number(process.env.METRICS_CLIENT_REBATE_SHARE_PERCENT) ||
                    defaultMetricsConfig.revenue.clientRebateSharePercent,
                effectiveRebatePercent: Number(process.env.METRICS_EFFECTIVE_REBATE_PERCENT) ||
                    defaultMetricsConfig.revenue.effectiveRebatePercent,
                interchangeCreatedPercent: Number(process.env.METRICS_INTERCHANGE_CREATED_PERCENT) ||
                    defaultMetricsConfig.revenue.interchangeCreatedPercent,
            },
            supplier: {
                optimizedSupplierRatePercent: Number(process.env.METRICS_OPTIMIZED_SUPPLIER_RATE_PERCENT) ||
                    defaultMetricsConfig.supplier.optimizedSupplierRatePercent,
            },
            paymentMethods: {
                digitalPaymentMethods: process.env.METRICS_DIGITAL_PAYMENT_METHODS?.split(',') ||
                    defaultMetricsConfig.paymentMethods.digitalPaymentMethods,
            },
        };
    }
    return config;
}
/**
 * Current metrics configuration instance.
 */
export const metricsConfig = loadMetricsConfig();
//# sourceMappingURL=metrics.config.js.map